import { render } from "./Tick.vue?vue&type=template&id=091c0fd6&scoped=true&ts=true"
import script from "./Tick.vue?vue&type=script&lang=ts"
export * from "./Tick.vue?vue&type=script&lang=ts"

import "./Tick.vue?vue&type=style&index=0&id=091c0fd6&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091c0fd6"]])

export default __exports__